import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _YupValidations_brand;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from '@glimmer/tracking';
import { getProperties } from '@ember/object';
import { object, setLocale } from 'yup';
import { restartableTask, timeout } from 'ember-concurrency';
const DEBOUNCE_MS = 100;

/**
 * Started with: https://mainmatter.com/blog/2021/12/08/validations-in-ember-apps/
 */
let YupValidations = (_class = (_YupValidations_brand = /*#__PURE__*/new WeakSet(), class YupValidations {
  constructor(context, shape) {
    _classPrivateMethodInitSpec(this, _YupValidations_brand);
    _defineProperty(this, "context", void 0);
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "shape", void 0);
    _initializerDefineProperty(this, "error", _descriptor, this);
    _initializerDefineProperty(this, "showAllErrors", _descriptor2, this);
    _initializerDefineProperty(this, "visibleErrors", _descriptor3, this);
    _defineProperty(this, "runValidator", _buildTask(() => ({
      context: this,
      generator: function* () {
        //wait for user input to stop
        yield timeout(DEBOUNCE_MS);
        const rhett = yield _assertClassBrand(_YupValidations_brand, this, _validate).call(this);
        //return the result of the validation and not the promise itself
        return rhett;
      }
    }), null, "runValidator", "restartable"));
    _defineProperty(this, "addErrorDisplaysFor", fields => {
      fields.forEach(field => this.addErrorDisplayFor(field));
    });
    _defineProperty(this, "addErrorDisplayFor", field => {
      this.runValidator.perform();
      if (!this.visibleErrors.includes(field)) {
        this.visibleErrors = [...this.visibleErrors, field];
      }
    });
    _defineProperty(this, "addErrorDisplayForAllFields", () => {
      this.showAllErrors = true;
    });
    _defineProperty(this, "clearErrorDisplay", () => {
      this.showAllErrors = false;
      this.visibleErrors = [];
    });
    _defineProperty(this, "removeErrorDisplayFor", field => {
      this.showAllErrors = false;
      if (this.visibleErrors.includes(field)) {
        this.visibleErrors = this.visibleErrors.filter(f => f !== field);
      }
    });
    this.context = context;
    this.shape = shape;
    this.schema = object().shape(shape);
  }
  get errorsByKey() {
    return this.error?.errors.reduce((acc, validationError) => {
      const key = validationError.path;
      if (!acc[key]) {
        acc[key] = [validationError];
      } else {
        acc[key].push(validationError);
      }
      return acc;
    }, {});
  }
  get errors() {
    if (!this.errorsByKey) {
      return {};
    }
    if (this.showAllErrors) {
      return this.errorsByKey;
    }
    return getProperties(this.errorsByKey, ...this.visibleErrors);
  }
  async isValid() {
    return (await _assertClassBrand(_YupValidations_brand, this, _validate).call(this)) === true;
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showAllErrors", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "visibleErrors", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class);
async function _validate() {
  try {
    await this.schema.validate(_assertClassBrand(_YupValidations_brand, this, _validationProperties).call(this), {
      abortEarly: false
    });
    this.error = null;
    return true;
  } catch (error) {
    this.error = error;
    return false;
  }
}
function _validationProperties() {
  return getProperties(this.context, ...Object.keys(this.shape));
}
export { YupValidations as default }; //call this function to set the error messages and their locale one time when this file is loaded
setupErrorMessages();
function setupErrorMessages() {
  setLocale({
    mixed: {
      required: required()
    },
    string: {
      min: min(['min']),
      max: max(['max']),
      email: isEmail()
    }
  });
}
function required() {
  return validationParams => {
    return {
      path: validationParams.path,
      messageKey: 'errors.blank',
      values: {}
    };
  };
}
function max(localeValues = []) {
  return validationParams => {
    return {
      path: validationParams.path,
      messageKey: 'errors.tooLong',
      values: getProperties(validationParams, ...localeValues)
    };
  };
}
function min(localeValues = []) {
  return validationParams => {
    return {
      path: validationParams.path,
      messageKey: 'errors.tooShort',
      values: getProperties(validationParams, ...localeValues)
    };
  };
}
function isEmail() {
  return validationParams => {
    return {
      path: validationParams.path,
      messageKey: 'errors.email',
      values: []
    };
  };
}